import type { EventType } from "@/lib/events/types";

const EVENT_COVER_DIR = "/brand/events";

const EVENT_SLUG_COVERS: Record<string, string> = {
  "demo-esemeny-01": "diagnosis",
  "demo-esemeny-02": "workshop",
  "demo-esemeny-03": "pediatrics",
  "demo-esemeny-04": "staff",
  "demo-esemeny-05": "digital",
  "demo-esemeny-06": "prevention",
  "demo-esemeny-07": "chronic",
  "demo-esemeny-08": "emergency",
  "demo-esemeny-09": "rural",
  "demo-esemeny-10": "meetup",
  "demo-esemeny-11": "mental",
  "demo-esemeny-12": "chronic",
  "demo-esemeny-13": "cardio",
  "demo-esemeny-14": "privacy",
  "demo-esemeny-15": "grants",
  "demo-esemeny-16": "digital",
  "demo-esemeny-17": "mentoring",
  "demo-esemeny-18": "staff",
  "demo-esemeny-19": "telemedicine",
  "demo-esemeny-20": "workshop",
};

const EVENT_TYPE_COVERS: Record<EventType, string> = {
  webinar: "diagnosis",
  training: "workshop",
  conference: "meetup",
  meetup: "meetup",
  community: "rural",
  online: "digital",
  platform: "workshop",
};

function coverPath(name: string) {
  return `${EVENT_COVER_DIR}/${name}.jpg`;
}

export function getEventCoverFallback(
  slug?: string | null,
  eventType?: EventType | null,
) {
  if (slug && EVENT_SLUG_COVERS[slug]) {
    return coverPath(EVENT_SLUG_COVERS[slug]);
  }

  if (eventType && EVENT_TYPE_COVERS[eventType]) {
    return coverPath(EVENT_TYPE_COVERS[eventType]);
  }

  return coverPath("workshop");
}

export function resolveEventCoverUrl(
  coverUrl: string | null | undefined,
  slug?: string | null,
  eventType?: EventType | null,
) {
  return coverUrl || getEventCoverFallback(slug, eventType);
}
